import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    const skip = NO_REFRESH.some((u) => (orig.url || "").includes(u));
    if (error.response?.status === 401 && !orig._retry && !skip) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const BOAT_CATEGORIES = ["29er", "49er", "49er FX", "Nacra 15", "Nacra 17"];
export const SOCIO_CATEGORIES = [
  "Atleta classi giovanili",
  "Atleta classi olimpiche",
  "Associato Armatore",
  "Componente del Consiglio direttivo",
];
export const ATHLETE_CATEGORIES = SOCIO_CATEGORIES.slice(0, 2);
export const REGATA_TYPES = ["Zonale", "Nazionale", "Internazionale"];
export const ANNUNCIO_CATEGORIE = ["Barca", "Vele", "Attrezzature", "Altro"];
export const MAX_FILE = 2 * 1024 * 1024;

export const fmtDate = (d) => (d && /^\d{4}-\d{2}-\d{2}/.test(d) ? d.slice(0, 10).split("-").reverse().join("/") : "-");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "-");
export const parseDay = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const todayStr = () => {
  const t = new Date();
  return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
};
export const fileUrl = (id) => `${API}/files/${id}`;
export const euro = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);
export const prezzoLabel = (n) => (n === null || n === undefined ? "Prezzo da concordare" : euro(n));
export const pagamentoLabel = (m) => (m === "bonifico" ? "Bon" : "Contanti");
export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-");
